import Vue from 'vue'
import axios from 'axios'

const baseURL = (process.env.NODE_ENV === 'development')
  ? (process.env.VUE_APP_API_LOCAL_URL || 'http://localhost:8000')
  : (process.env.VUE_APP_API_URL || '')
const baseURLAPI = baseURL ? baseURL + '/api' : ''

axios.defaults.baseURL = baseURLAPI

// Set Content-Type to JSON for POST/PUT/PATCH requests
axios.interceptors.request.use(config => {
  if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
    // Only set Content-Type if not already set
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json'
    }
    // If data is an object and Content-Type is JSON, stringify it
    if (config.headers['Content-Type'] === 'application/json' && typeof config.data === 'object' && !(config.data instanceof FormData)) {
      config.data = JSON.stringify(config.data)
    }
  }
  return config
})

// On an expired/invalid token, clear it and send the user to login instead of
// leaving them stuck with generic errors on every subsequent request.
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      delete axios.defaults.headers.common.Authorization
      const path = window.location.pathname || ''
      const authPages = ['/login', '/register', '/reset-password', '/forgot-password']
      if (!authPages.some(p => path.startsWith(p))) {
        window.location.assign('/login')
      }
    }
    return Promise.reject(error)
  }
)

const token = localStorage.getItem('token')
if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`

const currency = process.env.VUE_APP_CURRENCY

export const formatCurrency = (val) => {
  if (currency === '$') {
    return `$${val}`
  }

  return `${val} ${currency}`
}

export const features = {
  registration_fee: process.env.VUE_APP_FEATURE_FEE === 'true',
  use_country: process.env.VUE_APP_USE_COUNTRY === 'true'
}

const data = {
  app: process.env.VUE_APP_NAME,
  isWff: process.env.VUE_APP_NAME === 'wff',
  title: process.env.VUE_APP_TITLE,
  baseURL: baseURL,
  baseURLAPI: baseURLAPI,
  currency
}

Vue.prototype.$feature = features
Vue.prototype.$formatCurrency = formatCurrency
Vue.prototype.$defaultErrorMessage = 'There was an error. Please try again.'
Vue.prototype.$config = data
Vue.prototype.$file = (path, filename, id = null) => {
  if (!filename) return null
  const subfolder = id ? `/${id}` : ''
  const base = `${baseURL}/files/${path}${subfolder}/${filename}`
  return base
}

export default data
